import { notificationManager } from '../Stores/NotificationManager'
import { userManager } from '@/Core/Managers'
import { restClient } from '@/Core'

export const LoadNotificationListTask = async ({ searchParams = {} } = {}) => {
    const uuid = userManager.user?.uuid
    const page = searchParams.page ?? 1

    if (!uuid) return

    if (notificationManager.isNotificationLoading) return

    notificationManager.setIsNotificationLoading(true)
    notificationManager.setIsLoadingFirstPage(page === 1)

    try {
        const { isReaded, type, ...restParams } = searchParams

        const filters: any[] = []
        if (isReaded === false) {
            filters.push({ field: 'isReaded', op: '=', value: false })
        }
        if (Array.isArray(type) && type.length > 0) {
            filters.push({ field: 'type', op: 'in', value: type })
        } else if (typeof type === 'string' && type) {
            filters.push({ field: 'type', op: '=', value: type })
        }

        // When the drawer is scoped to a single entity (e.g. an assignment),
        // restrict the list to that entity's notifications.
        const { entityFilter } = notificationManager
        if (entityFilter) {
            filters.push({ field: 'entityCode', op: '=', value: entityFilter.entityCode })
            filters.push({ field: 'entityUuid', op: '=', value: entityFilter.entityUuid })
        }

        const normalizedSearchParams = filters.length > 0
            ? { ...restParams, filters: JSON.stringify({ and: filters }) }
            : restParams

        // forceRefresh: the notification list reflects read/unread state that
        // changes on every click. RestClient caches GET promises for ~30s, so
        // without this a reload right after marking an item read returns the
        // stale cached list and the item flips back to unread.
        const response = await restClient.get(
            '/services/user/notifications',
            { searchParams: normalizedSearchParams },
            { forceRefresh: true }
        )

        const items = response?.items || []
        const meta = response?.meta

        if (Array.isArray(items)) {
            if (page > 1) {
                notificationManager.appendNotifications(items)
            } else {
                notificationManager.setNotifications(items)
            }
        }

        if (meta) {
            notificationManager.setPagination({
                page: meta.page,
                limit: meta.limit,
                total: meta.total,
            })
        }
    } catch (error) {
        console.warn('LoadNotificationListTask error:', error)
    } finally {
        notificationManager.setIsNotificationLoading(false)
        notificationManager.setIsLoadingFirstPage(false)
    }
}
